import React from 'react';
import classNames from 'classnames';

import {ErrorField} from 'components/Fields';

import './styles.css';

const TextAreaField = ({
  input: {onBlur, onChange, value},
  placeholder,
  className,
  disabled,
  meta: {touched, error}
}: any) => {
  return (
    <div className="TextAreaField">
      <textarea
        onChange={onChange}
        onBlur={onBlur}
        className={classNames(
          {error: touched && error, disabled: disabled},
          className
        )}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
      />
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default TextAreaField;
